import { render, staticRenderFns } from "./BackendHome.html?vue&type=template&id=c9b70d98&scoped=true&"
import script from "./BackendHome.js?vue&type=script&lang=js&"
export * from "./BackendHome.js?vue&type=script&lang=js&"
import style0 from "./BackendHome.scss?vue&type=style&index=0&id=c9b70d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b70d98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSimpleTable})
